/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import Select, { components } from 'react-select';
import _clone from 'lodash/cloneDeep';
import PropTypes from 'prop-types';

import { DropdownIndicator, generateSelectStyles, ValueContainer } from '../../../../common/generateSelectStyling';

const Option = (props) => (
    <components.Option {...props}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {props.data.icon && (
                    <img
                        src={props.data.icon}
                        alt=""
                        style={{ width: 17, marginRight: 5, opacity: props.data.isDisabled ? '0.5' : 1 }}
                    />
                )}
                <span>{props.data.label}</span>
            </div>
            {!props.data.isDisabled && (
                <i className="material-icons" style={{ fontSize: 17 }}>
                    add
                </i>
            )}
        </div>
    </components.Option>
);

Option.propTypes = {
    data: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        isDisabled: PropTypes.bool.isRequired,
    }).isRequired,
};

const SingleValue = (props) => (
    <components.SingleValue {...props}>
        {props.data.icon && <img src={props.data.icon} alt="" style={{ width: 17 }} />}
        <span>{props.data.label}</span>
    </components.SingleValue>
);

SingleValue.propTypes = {
    data: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
};

export default class SocialSelect extends PureComponent {
    render() {
        const { icons, onChange, colorIcons } = this.props;
        const options = _clone(icons)
            .sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0))
            .sort((op1, op2) => op1.active - op2.active)
            .map(({ title, src, active }) => ({
                value: title,
                label: title
                    .split('-')
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(' '),
                icon: colorIcons ? src.color : src.bw,
                isDisabled: active,
            }));
        return (
            <Select
                options={options}
                components={{ DropdownIndicator, Option, SingleValue, ValueContainer }}
                styles={generateSelectStyles({ hasIcon: true })}
                onChange={onChange}
                placeholder="Add social link"
                controlShouldRenderValue={false}
            />
        );
    }
}

SocialSelect.propTypes = {
    icons: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    colorIcons: PropTypes.bool.isRequired,
};
